module.exports = __webpack_public_path__ + "img/united-states.svg";